import { ErrorHandler, Injectable,NgZone} from '@angular/core';
import * as Sentry from '@sentry/angular';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
    constructor(private ngZone: NgZone) {}
    handleError(error) {
       // Check if it's an HTTP error response
        if (error instanceof HttpErrorResponse) {
            // Transform the HTTP error response
            const transformedError = {
            message: error.message,
            name: error.name,
            status: error.status,
            statusText: error.statusText,
            url: error.url,
            error: error.error,
            headers: error.headers
            };
    
            this.ngZone.run(() => {
            Sentry.captureException(transformedError);
            });
        } else {
            // Capture other types of errors
            this.ngZone.run(() => {
            Sentry.captureException(error.originalError || error);
            });
        }
        throw error;
    }
}